export default __webpack_public_path__ + "images/home-ico.svg";